let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("crVgG")).then(() => parcelRequire('5Vlto'));